<template>
	<div>
		<el-tooltip effect="dark" placement="right" popper-class="tip-class">
			<div slot="content">
				单据线下支付金额、单据微信支付金额、单据微企付支付金额、单据预付货款支付金额、单据云资源-网商支付金额、云资金-汇付支付金额，<br/>上述字段只支持统计整单支付金额，不支持按明细查询，如需按明细统计合计，需将上述字段取消勾选显示。
			</div>
			<img src="~/images/icon/tooltip-icon.png" style="margin-left: 10px;cursor:pointer">
		</el-tooltip>
	</div>
</template>
<script>
export default {
	name: 'IconTip',
	data () {
		return {
		}
	},
	created () {

	},
	methods: {

	}
}
</script>
<style lang="stylus" scoped>

</style>
